import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import { CustomerProvider } from './context/CustomerContext';
import { AuthProvider } from './context/AuthContext';
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import Customers from './pages/Customers';
import CustomerDetail from './pages/CustomerDetail';
import LeadDetail from './pages/LeadDetail';
import Leads from './pages/Leads';
import Sales from './pages/Sales';
import Inventory from './pages/Inventory';
import VehicleDetail from './pages/VehicleDetail';
import Analytics from './pages/Analytics';
import AITools from './pages/AITools';
import Users from './pages/Users';
import Settings from './pages/Settings';
import Messages from './pages/Messages';
import AIAssistant from './components/AIFeatures/AIAssistant';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <CustomerProvider>
        <Router>
          <Layout>
            <Routes>
              <Route path="/" element={<Dashboard />} />
              <Route path="/customers" element={<Customers />} />
              <Route path="/customers/:id" element={<CustomerDetail />} />
              <Route path="/leads" element={<Leads />} />
              <Route path="/leads/:id" element={<LeadDetail />} />
              <Route path="/sales" element={<Sales />} />
              <Route path="/inventory" element={<Inventory />} />
              <Route path="/inventory/:id" element={<VehicleDetail />} />
              <Route path="/analytics" element={<Analytics />} />
              <Route path="/ai-tools" element={<AITools />} />
              <Route path="/users" element={<Users />} />
              <Route path="/settings" element={<Settings />} />
              <Route path="/messages" element={<Messages />} />
            </Routes>
            <AIAssistant />
          </Layout>
        </Router>
      </CustomerProvider>
    </AuthProvider>
  );
}

export default App;